import {
  FETCH_UPDATE_PROJECT_TEMPLATE_TASK_REQUEST,
  FETCH_UPDATE_PROJECT_TEMPLATE_TASK_SUCCESS,
  FETCH_UPDATE_PROJECT_TEMPLATE_TASK_FALUIRE,
} from './updateProjectTemplateTaskTypes'

const initialState = {
  loading: false,
  updateProjectTemplateTask: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_UPDATE_PROJECT_TEMPLATE_TASK_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_UPDATE_PROJECT_TEMPLATE_TASK_SUCCESS : return {
      ...state,
      updateProjectTemplateTask: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_UPDATE_PROJECT_TEMPLATE_TASK_FALUIRE : return {
      ...state,
      loading: false,
      updateProjectTemplateTask: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
